
//获取cookie、
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return (arr[2]);
    else
      return null;
  }
  // function getCookie(name) {
  //   var cookies = document.cookie;
  //   var list = cookies.split(";");          // 解析出名/值对列表
  //   for(var i = 0; i < list.length; i++) {
  //       var arr = list[i].split("=");          // 解析出名和值
  //         if(arr[0] == name)
  //           return decodeURIComponent(arr[1]);   // 对cookie值解码
  //    } 
  //   return "";
  // }
  //设置cookie,增加到vue实例方便全局调用
  export function setCookie (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
  };
  // function setcookie(name, value, daysTolive) {
  //   let cookie = name + "=" + encodeURIComponent(value);
  //       if (typeof daysTolive === "number"){
  //           cookie += "; max-age =" + (daysTolive * 60 * 60 * 24);
  //           document.cookie = cookie;
  //       }
  // }
  
  //删除cookie
  export function delCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  };